<template>
  <div :class="{ trial: true, fixed: true }">
    <div class="trial_tl">
      <span class="serve"></span>
      <div>400-6696-280</div>
      <span class="we"></span>
      <div @click="setScan">微信咨询</div>
    </div>
    <div class="wescan" v-show="data.scan">
      <img src="../assets/scan.png" alt="" />
    </div>
    <div class="free flex" @click="$router.push('/experience')">
      获取产品演示
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, reactive, ref, toRefs } from "vue";
import { useRoute } from "vue-router";
const data = reactive({
  fixed: false,
  scan: false,
});

const props = defineProps({
  height: Number,
  default: 4300,
});

const getzoomRatio = () => {
  let ratio = 0;
  const screen = window.screen;
  const ua = navigator.userAgent.toLowerCase();
  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  } else if (~ua.indexOf("msie")) {
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI;
    }
  } else if (
    window.outerWidth !== undefined &&
    window.innerWidth !== undefined
  ) {
    ratio = window.outerWidth / window.innerWidth;
  }
  if (ratio) {
    ratio = Math.round(ratio * 100);
  }
  return ratio;
};

function setScan() {
  data.scan = !data.scan;
}
function scrollBar(e) {
  data.scan = false;
  let h = document.documentElement.scrollTop;

  const a = getzoomRatio();
  const H = document.documentElement.scrollHeight;
  console.log(h, H, a);

  console.log(H - h, 2000 - (a * 10 + 300));
  // 方法

  if (H - h > 2000 - (a * 10 + 300)) {
    data.fixed = true;
  } else {
    data.fixed = false;
  }
}
onMounted(() => {
  window.addEventListener("scroll", scrollBar);
});
onUnmounted(() => {
  window.removeEventListener("scroll", scrollBar);
});
</script>

<style lang="scss" scoped>
.trial {
  display: flex;
  justify-content: space-between;
  display: none;

  .trial_tl {
    display: flex;

    .serve {
      background: url(../assets/serveFbig.png) no-repeat;
      width: 32px;
      height: 32px;
      background-size: 100%, 100%;
      display: inline-block;
      margin-right: 20px;
    }

    .we {
      background: url(../assets/Wbig.png) no-repeat;
      width: 32px;
      height: 32px;
      margin-left: 509px;
      background-size: 100%, 100%;
      display: inline-block;
      margin-right: 20px;
    }

    margin-left: 160px;
    margin-top: 21px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
  }

  height: 72px;
  background: #34c88a;
  max-width: 1920px;
  // position:fixed;
  bottom: 0px;
  z-index: 999;
  left: 0px;
  right: 0px;
  cursor: pointer;
  .wescan {
    width: 140px;
    height: 131px;
    position: fixed;
    bottom: 72px;
    left: 898px;

    img {
      width: 120px;
      height: 110px;
      background: url(../assets/scan.png) no-repeat;
      background-size: 100%, 100%;
    }

    background-color: #fff;
    padding: 10px;
  }

  .free {
    margin-top: 17px;
    position: absolute;
    margin-right: 160px;
    top: 1px;
    right: 16px;
    color: #34c88a;
    width: 160px;
    height: 38px;
    background: #ffffff;
    border-radius: 19px;
    cursor: pointer;
  }
}
</style>
